// Auth guard — redirects unauthenticated users to /login with state.from so
// App.js can navigate back to the original URL after sign-in.

import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';

// The other half of the `state.from` contract, kept in this file on purpose.
// ProtectedRoute stores the WHOLE location below — pathname, search, and hash —
// and the reader used to take `.pathname` alone. That silently dropped the
// query string on every deep link that survived a login round-trip: a typed
// `/manage-workspace?tab=billing` came back as `/manage-workspace` and resolved to the
// Members tab, while clicking the same tab worked, because clicking never
// makes the round-trip. The two halves disagreed precisely because they lived
// in two files, so they live in one now.
export function returnToFromState(state) {
    const from = state?.from;
    if (!from || !from.pathname) return '/';
    return `${from.pathname}${from.search || ''}${from.hash || ''}`;
}

export default function ProtectedRoute({ user }) {
    const location = useLocation();
    if (!user) {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }
    return <Outlet />;
}
